export default __webpack_public_path__ + "static/media/lebron_banner.d7acffcf.png";